import { PROJECT_STATUS } from './project';
import { Organisation } from './organisation.interface';

export interface ApplicationInterface {
  info: ApplicationInfo;
  dateCreated?: string;
  lastUpdated?: string;
  setup: ApplicationSetup;
  assets?: ApplicationAssets;
  rating?: ApplicationRating;
}

export interface ApplicationInfo {
  organisationId?: string | number;
  applicationId?: string;
  name: string;
  platforms: string[];
  description?: string;
  username?: string;
  cluster?: string;
  website: string | null;
  country: string;
  version?: string;
  supportEmail?: string | null;
  appLinks?: ApplicationLinks;
  privacyUrl?: string | null;
  termsUrl?: string | null;
  shortDescription?: string;
  dataUsePurpose?: string;
  hasPermissionsForm?: boolean;
  [index: string]: any;
}

export interface ApplicationLinks {
  ios?: string | null;
  web?: string | null;
  android?: string | null;
  [index: string]: string | undefined | null;
}
export interface ApiApplicationInterface {
  info: ApiApplicationInfo;
  setup: ApiApplicationSetup;
}

export interface ApiApplicationInfo {
  applicationId?: string;
  name: string;
  platforms: string[];
  description?: string;
  website: string;
  appLinks: ApplicationLinks;
  country: string;
  version?: string;
  supportEmail?: string;
  privacyUrl?: string;
  termsUrl?: string;
  hasPermissionsForm?: boolean;
  [index: string]: string | boolean | string[] | ApplicationLinks | undefined;
}

export interface ApiApplicationSetup {
  namespace: string;
  callbackUrl: string[];
  [index: string]: string | string[] | undefined;
}

export interface ApplicationSetup {
  namespace: string;
  validRedirectUris: string[];
  status: PROJECT_STATUS;
  [index: string]: string | string[] | undefined;
}

export interface ApplicationAssets {
  appLogoUrl?: ApplicationAssetFile;
  screenshotsUrl?: ApplicationAssetFile[];
}

export interface ApplicationDeveloper {
  developerName: string;
  developerWebsite?: string;
  developerCountry?: string;
  developerLogoUrl?: string;
}

export interface ApplicationRating {
  rating?: string;
}

export interface ApplicationError {
  isValid: boolean;
  errors: Array<string>;
}

export enum SaveStatusType {
  Save = 'Save',
  Saving = 'Saving',
  Saved = 'Saved',
}

export enum SubmitStatusType {
  SubmitReview = 'Submit for review',
  SubmitUpdate = 'Submit an update',
  Submitted = 'Submitted',
}

export interface RatingRadioInterface {
  first: string;
  second: string;
  third: string;
  [index: string]: string;
}
export interface ApiDevPortalAppStatus {
  message: string;
  status: string;
  isEditable: boolean;
  isDeletable: boolean;
  linkedAppId?: string;
}

export interface ApplicationAssetFile {
  fileId: string;
  contentUrl?: string;
}

export interface ApplicationManagerInterface {
  application: ApplicationInterface;
  organisation: Organisation;
}

export interface AppFormErrors {
  name?: string;
  applicationId?: string;
  website?: string;
  country?: string;
  namespace?: string;
  supportEmail?: string;
  termsUrl?: string;
  privacyUrl?: string;
  platforms?: string;
  iOSLink?: string;
  AndroidLink?: string;
  WebLink?: string;
  iOSCallbackURL?: string;
  callbacks?: string;
  AndroidCallbackURL?: string;
  WebCallbackURL?: string;
  [index: string]: string | undefined;
}
